<template>
  <div v-if="alert.status === 'success' || alert.status === 'info'">
    <Alert class="mt-2" status="success">
      {{ alert.message }}
    </Alert>
    <button @click="redirectUser" class="btn btn-primary">
      {{alert.status ? 'Login' : 'Esci'}}
    </button>
  </div>
  <FormContainer class="signup-form" v-else @submitForm="submit">
    <div class="container-fluid px-0">
      <div class="row">
        <FormInputTextWidget
          class="col-12 col-lg-6"
          label="Nome"
          placeholder="Mario"
          v-model="user.name"
          :errorMsg="errorHash.name"
          type="text"
          v-if="isNewUser"
          @input="removeError('name')"
        />
        <FormInputTextWidget
          class="col-12 col-lg-6"
          label="Cognome"
          placeholder="Rossi"
          v-model="user.surname"
          :errorMsg="errorHash.surname"
          type="text"
          v-if="isNewUser"
          @input="removeError('surname')"
        />
        <div class="col-12">
          <label class="form-label" for="signup-email">Indirizzo email</label>
          <input class="form-control" id="signup-email" type="text" :value="reservedUser.email" readonly>
        </div>

        <FormInputTextWidget
          class="col-12 col-lg-6"
          label="Password"
          placeholder="Password"
          v-model="user.password"
          v-if="isNewUser"
          :errorMsg="errorHash.password"
          type="password"
          @input="removeError('password')"
        />

        <FormInputTextWidget
          class="col-12 col-lg-6"
          label="Conferma Password"
          placeholder=""
          v-model="passwordConfirmation"
          v-if="isNewUser"
          :errorMsg="errorHash.confirmPassword"
          type="password"
          @input="removeError('confirmPassword')"
        />

        <div class="col-12">
          <label class="form-label">Ruolo</label>
          <div class="role d-flex align-items-center">
            <i class="fas fa-check text-success mr-1"></i>
            <span class="text-muted small">
              {{ reservedUser.role.name | role() }}
              {{ reservedUser.role.company ? 'presso ' + reservedUser.role.company.name : '' }}
            </span>
          </div>
        </div>
        <FormInputCheckboxWidget
          v-model="contract"
          class="col-12"
          :class="{ 'pb-4': !isNewUser }"
          :errorMsg="errorHash.contract"
          @input="removeError('contract')"
        >
          <template v-slot:label>
            Contratto
          </template>
          <p class="small text-muted">Dichiaro di conoscere ed accetto di applicare le condizioni contrattuali sottoscritte con la Mercurio s.r.l.s. nel rapporto con l'azienda individuata nel presente form, in particolare per quanto riguarda le condizioni previste dai paragrafi: utenze e livelli di accesso, corrispettivo, fatturazione e pagamenti, dichiarazioni e garanzie, responsabilità delle informazioni pubblicate, responsabilità di utilizzo della piattaforma, eventuali danni derivanti dall'utilizzo della piattaforma, responsabilità inadempimenti clienti, modalità di trattamento dei dati del cliente.</p>
        </FormInputCheckboxWidget>
        <FormInputCheckboxWidget
          v-model="privacy"
          v-if="isNewUser"
          class="col-12"
          :errorMsg="errorHash.privacy"
          @input="removeError('privacy')"
        >
          <template v-slot:label>
            Privacy &amp; GDPR
          </template>
            <p class="small text-muted">Registrandosi si accettano le condizioni espresse all'interno del contratto. Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>
        </FormInputCheckboxWidget>
      </div>
      <button class="btn btn-primary btn-block mb-2" type="submit">{{ isNewUser ? 'Registrati' : 'Accetta invito'}}</button>
      <AwlConfirm
        class="btn-block text-right"
        status="link text-danger"
        @confirm="declines"
        title="Declina invito"
      >
        Sei sicuro di voler declinare l'invito?
      </AwlConfirm>
    </div>

  </FormContainer>
</template>

<script>
import validateMixin from '../../../libs/Form/mixins/validate';
import formatRolesFilter from '@/filters/formatRoles';

export default {
  components: {
    Alert: () => import('../../../libs/Feedback/components/Alert'),
    FormContainer: () => import('../../../libs/Form/components/FormContainer'),
    FormInputTextWidget: () => import('../../../libs/Form/components/Inputs/Widgets/FormInputTextWidget'),
    FormInputCheckboxWidget: () => import('../../../libs/Form/components/Inputs/Widgets/FormInputCheckboxWidget'),
    AwlConfirm: () => import('../../../libs/Modals/components/AwlConfirm'),
  },
  mixins: [validateMixin],
  filters: {
    role: formatRolesFilter,
  },
  props: {
    reservedUser: {
      type: Object,
      required: true,
    },
    isNewUser: {
      type: Boolean,
      default: false,
    },
    token: {
      type: String,
      required: true,
    },
    md5: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      alert: {
        status: null,
        message: null,
      },
      passwordConfirmation: null,
      privacy: false,
      contract: false,
      user: {
        name: null,
        surname: null,
        password: null,
      },
    };
  },
  mounted () {
    if (this.reservedUser.name) {
      this.user.name = this.reservedUser.name;
    }
    if (this.reservedUser.surname) {
      this.user.surname = this.reservedUser.surname;
    }
  },
  methods: {
    submit () {
      const emitter = this.isNewUser ? 'signed' : 'accepted';

      return this.signUp(user => {
        this.$emit(emitter, user);
      });
    },
    signUp (callbackFunction) {
      if (!this.isValid()) {
        return;
      }

      this.$api.registerUser(this.md5, this.token, this.user).then(() => {
        this.cleanLocalStorage();

        this.alert.status = 'success';
        this.alert.message = 'Profilo associato con successo';

        if (callbackFunction) {
          callbackFunction({
            ...this.reservedUser,
            ...this.user,
          });
        }
      }).catch(err => {
        if (err.response.data.msg) {
          this.alert.status = 'danger';
          this.alert.message = err.response.data.msg;
        }
      });
    },
    declines () {
      this.$log.debug('declines');
      this.$api.declinesRegisterUser(this.md5, this.token).then(() => {
        this.cleanLocalStorage();

        this.alert.status = 'info';
        this.alert.message = 'Invito declinato con successo.';
        this.$emit('declined');
      }).catch(err => {
        if (err.response.data.msg) {
          this.alert.status = 'danger';
          this.alert.message = err.response.data.msg;
        }
      });
    },
    isValid () {
      this.clearErrors();

      if (!this.contract) {
        this.addError('Devi accettare il contratto', 'contract');
      }

      if (!this.isNewUser) {
        return !this.hasErrors;
      }

      // name
      if (!this.user.name) {
        this.addError('Inserisci il nome', 'name');
      }
      // surname
      if (!this.user.surname) {
        this.addError('Inserisci il cognome', 'surname');
      }
      // Password
      // ConfirmPassword
      if (!this.user.password) {
        this.addError('Inserisci la password', 'password');
      } else if (this.user.password.length < 8 || !this.user.password.match(/\d|[^\w\s]/)) {
        this.addError('La password deve avere almeno 8 caratteri, compreso un numero o un simbolo.', 'password');
      } else if (!this.passwordConfirmation) {
        this.addError('Inserisci la password di conferma', 'confirmPassword');
      } else if (this.user.password !== this.passwordConfirmation) {
        this.addError('La password e la password di conferma devono essere uguali', 'confirmPassword');
      }
      // privacy
      if (!this.privacy) {
        this.addError('Devi accettare la Privacy per poter proseguire', 'privacy');
      }

      return !this.hasErrors;
    },
    redirectUser () {
      return this.$router.push({ name: 'root' });
    },
    cleanLocalStorage () {
      this.$localStorage.delete('signup-email');
      this.$localStorage.delete('signup-token');
    },
    resetFeedBack () {
      this.alert.status = null;
      this.alert.message = null;
    },
  },
};

</script>
